<template>
    <ModalComponent
        :name="'editar-base-' + base.id"
        :title="'Editar deportista ' + base.nombre"
        v-on:close="() => close(false)"
    >
        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit">
            <div class="row">
                <div class="col-12">
                    <FormInput label="Nombre" name="nombre"  id="email" rules="required" rows="3" v-model="base.nombre" />
                </div>
                <div class="col-12 text-center">
                    <Button type="submit" name="button">GUARDAR</Button>
                </div>
            </div>
        </ValidationObserver>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: ['base'],
        data() {
            return {
                loading: false
            }
        },
        methods: {
            close(creado) {
                this.$emit('close', 'add-base', creado);
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.editar();
                }
            },
            editar() {
                this.loading = true;

                const params = {
                    filters : {},
                    nombre: this.base.nombre,
                    base_id: this.base.id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.comunicados.bases.editar'), params).then(res => {
                    this.expand = [];
                    this.$toast.success(res.data.message);
                    this.close(true);
                }).finally(() => this.loading = false);
            },
        },
        components: {
            ModalComponent
        }
    }
</script>
